import mobileAdjustment from "../GeneralMobileAdjustments";

class MobileRankingControlView {

    constructor() { }

    afterRender(control) {
        let element = mobileAdjustment.adjustMobileControl(control);
        element.find("div:first").css("width","100%");
    }
}

const mobileRankingControlView = new MobileRankingControlView();
export default mobileRankingControlView;
